import { Component } from '@angular/core';
import { DataService } from '../services/data.service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from '../services/message.service';

declare var Plaid: any;

@Component({
  selector: 'app-plaid',
  templateUrl: './plaid.component.html',
  styleUrls: ['./plaid.component.css'],
})
export class PlaidComponent {
  url: string = 'plaid';
  form!: FormGroup;
  loading: boolean = false;
  banks: Array<any> = [];
  transactions: Array<any> = [];
  step = 1;
  step_name = '';
  accounts: Array<any> = [];

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Merchant',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Banks',
      route: '/numbers/finance/plaid',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'Analysis',
      route: '/numbers/finance/analysis',
    },
  ];

  resumenCardsTwo = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Finance',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Accounting',
      route: '/numbers/accounting',
    },
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private router: Router,
    private messageService: MessageService,
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    //this.resetFormAccountsId();
    this.getData();
  }

  private initForm(): void {
    this.form = this.fb.group({
      public_token: [''],
      access_token: [''],
      institution: [''],
      institution_id: [''],
      /* institutions_id: this.fb.array([
        this.fb.group({
          institution_id: ['', [Validators.required]],
        }),
      ]), */
    });
  }

  getData(): void {
    this.dataService.getData(this.url).subscribe((response) => {
      console.log('response', response);

      if (response) {
        this.banks = response.data;
      }
    });
  }

  openPlaidLink() {
    console.log('fr openPlaidLink');
    this.dataService
      .postData(`${this.url}/createLinkToken`, this.form.value)
      .subscribe({
        next: (response: any) => {
          console.log('Respuesta del servidor:', response);
          if (response && response.rst === true) {
            //this.messageService.add('Surcharge creado exitosamente', 'success');
            //this.router.navigate(['/logistics/fees/surcharges']);

            const handler = Plaid.create({
              token: response.data.link_token,
              onSuccess: (public_token: string, metadata: any) => {
                console.log('Success:', public_token, metadata);
                this.form.patchValue({
                  public_token: public_token,
                  access_token: '',
                  institution: metadata.institution.name,
                  institution_id: metadata.institution.institution_id,
                });
                this.exchangePublicToken();
              },
              onExit: (err: any, metadata: any) => {
                console.error('Exit:', err, metadata);
              },
            });
            handler.open();
          } else {
            // this.messageService.add(response?.msg || 'Error al crear el surcharge', 'danger');
            //this.router.navigate(['/logistics/fees/surcharges']);
          }
          this.loading = false;
        },
        error: (error) => {
          console.error('Error al crear:', error);
          // this.messageService.add('Error al crear el surcharge: ' + (error.error?.msg || error.message), 'danger');
          //this.router.navigate(['/logistics/fees/surcharges']);
          this.loading = false;
        },
      });
    //user_good
    //pass_good
    //1234
  }

  pru() {
    console.log('access_token en pru', this.form.value);
    //this.getTransactions();
  }
  //Para transacciones (transactions/get):
  //Para saldos (accounts/balance/get):
  exchangePublicToken() {
    this.dataService
      .postData(`${this.url}/exchangePublicToken`, this.form.value)
      .subscribe({
        next: (response: any) => {
          console.log('Respuesta del serv exchangePublicToken:', response);
          if (response && response.rst === true) {
            //this.messageService.add('Surcharge creado exitosamente', 'success');
            //this.router.navigate(['/logistics/fees/surcharges']);

            this.getAccounts(response.accessToken);
            this.getTransactions(response.accessToken);
          } else {
            // this.messageService.add(response?.msg || 'Error al crear el surcharge', 'danger');
            //this.router.navigate(['/logistics/fees/surcharges']);
          }
          this.loading = false;
        },
        error: (error) => {
          console.error('Error al crear:', error);
          this.messageService.add(
            'Error: ' + (error.error?.msg || error.message),
            'secondary',
          );
          this.loading = false;
        },
      });
  }

  //traer todos datos de la cuenta
  getAccounts(access_token: string) {
    this.form.patchValue({
      access_token: access_token,
    });

    this.dataService
      .postData(`${this.url}/getAccounts`, this.form.value)
      .subscribe({
        next: (response: any) => {
          console.log('Respuesta del serv getAccounts:', response);
          if (response && response.rst === true) {
            //this.messageService.add('Surcharge creado exitosamente', 'success');
            this.form.patchValue({
              institution_id: response.data.item.institution_id,
            });

            //esto para recorrer accounts de ser necesario
            //console.log('despues de for en getAccounts', this.form.value);
            //this.getInstitutions()
          } else {
            // this.messageService.add(response?.msg || 'Error al crear el surcharge', 'danger');
            //this.router.navigate(['/logistics/fees/surcharges']);
          }
          this.loading = false;
        },
        error: (error) => {
          console.error('Error al crear:', error);
          // this.messageService.add('Error al crear el surcharge: ' + (error.error?.msg || error.message), 'danger');
          //this.router.navigate(['/logistics/fees/surcharges']);
          this.loading = false;
        },
      });
  }

  getTransactions(access_token: string) {
    this.form.patchValue({
      access_token: access_token,
    });

    this.dataService
      .postData(`${this.url}/getTransactions`, this.form.value)
      .subscribe({
        next: (response: any) => {
          console.log('Respuesta del serv getTransactions:', response);
          if (response && response.rst) {
            //this.messageService.add('Surcharge creado exitosamente', 'success');
            this.transactions = response.data.transactions;
            this.accounts = response.data.accounts;
          } else {
            // this.messageService.add(response?.msg || 'Error al crear el surcharge', 'danger');
          }
          this.loading = false;
        },
        error: (error) => {
          console.error('Error al crear:', error);
          // this.messageService.add('Error al crear el surcharge: ' + (error.error?.msg || error.message), 'danger');
          //this.router.navigate(['/logistics/fees/surcharges']);
          this.loading = false;
        },
      });
  }

  getInstitutions() {
    this.dataService
      .postData(`${this.url}/getInstitutions`, this.form.value)
      .subscribe({
        next: (response: any) => {
          console.log('Respuesta del serv getInstitutions:', response);
          if (response && response.rst === true) {
            //this.messageService.add('Surcharge creado exitosamente', 'success');
            //this.router.navigate(['/logistics/fees/surcharges']);
          } else {
            // this.messageService.add(response?.msg || 'Error al crear el surcharge', 'danger');
            //this.router.navigate(['/logistics/fees/surcharges']);
          }
          this.loading = false;
        },
        error: (error) => {
          console.error('Error al crear:', error);
          // this.messageService.add('Error al crear el surcharge: ' + (error.error?.msg || error.message), 'danger');
          //this.router.navigate(['/logistics/fees/surcharges']);
          this.loading = false;
        },
      });
  }

  /* get accountsId(): FormArray<FormGroup> {
    return this.form.get('institutions_id') as FormArray<FormGroup>;
  }

  resetFormAccountsId() {
    const institutions_id_array = this.form.get('institutions_id') as FormArray;

    while (institutions_id_array.length) {
      institutions_id_array.removeAt(0);
    }
  } */

  changeStep(step: number) {
    console.log('step', step);
    this.step = step;
    console.log('this.banks', this.banks);
    this.step_name = this.banks[step].institution;
  }
}
